var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Color",
    transform: "translate(-1403 -853)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5303",
    "data-name": "Rectangle 5303",
    width: 28,
    height: 28,
    transform: "translate(1403 853)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-color-5413151_1_",
    "data-name": "noun-color-5413151 (1)",
    transform: "translate(1404.012 854)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(1.988 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34308",
    "data-name": "Path 34308",
    d: "M12.844,2.009a11.285,11.285,0,0,0-1.612,22.376,2.4,2.4,0,0,0,.427.039,2.305,2.305,0,0,0,1.48-.534,2.794,2.794,0,0,0,.95-2.2v-2.1a.774.774,0,0,1,.306-.625.859.859,0,0,1,.747-.143c2.961.786,5.562.474,7.322-.879a5.61,5.61,0,0,0,2.1-4.649A11.285,11.285,0,0,0,12.844,2.009ZM21.48,16.656c-1.332,1.025-3.49,1.243-5.926.6a2.459,2.459,0,0,0-2.143.424,2.385,2.385,0,0,0-.934,1.9v2.1a1.222,1.222,0,0,1-.367.967.692.692,0,0,1-.584.148,9.722,9.722,0,0,1-7.909-9.893A9.825,9.825,0,0,1,12.906,3.62c.127-.007.255-.007.377-.007a9.673,9.673,0,0,1,9.673,9.673,4.006,4.006,0,0,1-1.476,3.371Z",
    transform: "translate(-1.988 -2)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_386",
    "data-name": "Ellipse 386",
    cx: 1.209,
    cy: 1.209,
    r: 1.209,
    transform: "translate(10.086 3.224)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_387",
    "data-name": "Ellipse 387",
    cx: 1.209,
    cy: 1.209,
    r: 1.209,
    transform: "translate(3.234 10.076)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_388",
    "data-name": "Ellipse 388",
    cx: 1.209,
    cy: 1.209,
    r: 1.209,
    transform: "translate(14.931 5.231)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_389",
    "data-name": "Ellipse 389",
    cx: 1.209,
    cy: 1.209,
    r: 1.209,
    transform: "translate(5.241 5.231)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColor);
export default __webpack_public_path__ + "static/media/Color.6729dbdada15cfa897ee7e294e79291c.svg";
export { ForwardRef as ReactComponent };